import { jsx as s } from "react/jsx-runtime";
import e from "react";
import i from "./index.es5837.js";
import { useCard as m } from "./index.es795.js";
const u = ({ children: t }) => {
  const { setIsAnyOfChildrenFocused: o } = m(), n = e.Children.map(t, (r) => e.isValidElement(r) ? e.cloneElement(r, {
    onFocus: () => o(!0),
    onBlur: () => o(!1)
  }) : r);
  return /* @__PURE__ */ s("div", { className: i.container, children: n });
};
export {
  u as FooterRightControls
};
//# sourceMappingURL=index.es5589.js.map
